

function Background() {
  return (
    <div className="background">
      <img className="background-img" 
        src="https://saloncw.square.site/uploads/b/62bd023d9ff6fb309150cdd2ad79d5835810b2b81c0c6b08ebbed95a1c8afb01/summerfield-336672_1920_1608089910.jpg" 
        alt="background hair" 
        
        />
    </div>
  )
}

export default Background